module.exports = __webpack_public_path__ + "img/logo.dc28d141.png";